import React from 'react';
import { TextField, Box, Grid } from '@mui/material';
import { format } from 'date-fns';

const DisplayDataComponent = ({ data }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return format(date, 'MM/dd/yyyy');
  };

  const transformLabel = (label) => {
    return label
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const filteredData = (({
    GENERAL_AVAILIBILITY_ID,
    ANNOUNCEMENT_ID,
    ELIGIBILITY_ID,
    APPLICATION_ID,
    APPLICANT_SSN,
    EVALUATION_RATING,
    CREATED_ON,
    UPDATED_ON,
    status,
    Notifiedon,
    Remark,
    // Backup,
    // AutoReminder,
    Createdon_logdate,
    Action,
    ActionType,
    Activity,
    Contacted,
    Scheduled,
    Interviewed,
    Selected,
    NotSelected,
    NotConsidered,
    ScheduledDate,
    CERTIFICATION_PID,
    StatusCode,
    reschedule,
    Reschedule_date
  }) => ({
    GENERAL_AVAILIBILITY_ID,
    ANNOUNCEMENT_ID,
    ELIGIBILITY_ID,
    APPLICATION_ID,
    APPLICANT_SSN,
    EVALUATION_RATING,
    CREATED_ON,
    UPDATED_ON,
    status,
    Notifiedon,
    Remark,
    // Backup,
    // AutoReminder,
    Createdon_logdate,
    Action,
    ActionType,
    Activity,
    Contacted,
    Scheduled,
    Interviewed,
    Selected,
    NotSelected,
    NotConsidered,
    ScheduledDate,
    CERTIFICATION_PID,
    StatusCode,
    reschedule,
    Reschedule_date
  }))(data);

  const formattedData = {
    ...filteredData,
    CREATED_ON: formatDate(filteredData.CREATED_ON),
    Notifiedon: formatDate(filteredData.Notifiedon),
    Createdon_logdate: formatDate(filteredData.Createdon_logdate),
  };

  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        {Object.entries(formattedData).map(([key, value], index) => (
          key !== 'Remark' && (
            <Grid item xs={12} sm={4} key={index}>
              <TextField
                label={transformLabel(key)}
                value={value === null ? '' : value}
                variant="outlined"
                fullWidth
                size="small"
                disabled
              />
            </Grid>
          )
        ))}
        <Grid item xs={12} sm={4}>
          <TextField
            label="Status"
            value={formattedData.status || ''}
            variant="outlined"
            fullWidth
            size="small"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Status Code"
            value={formattedData.StatusCode || ''}
            variant="outlined"
            fullWidth
            size="small"
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Remark"
            value={formattedData.Remark || ''}
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            disabled
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DisplayDataComponent
